import React, { useCallback } from 'react';
import { Icon } from '../Icon';
import { itemsPerPageOptions } from '@workspace/constants';
import { Typography } from '..';

interface ItemsPerPageSelectorProps {
  itemsPerPage: number;
  onItemsPerPageChange: (itemsPerPage: number) => void;
}

export function ItemsPerPageSelector({ itemsPerPage, onItemsPerPageChange }: ItemsPerPageSelectorProps) {
  const handleItemsPerPageChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      onItemsPerPageChange(Number(e.target.value));
    },
    [onItemsPerPageChange],
  );

  return (
    <div className="flex items-center gap-3">
      <Typography variant="bodyMd" className="text-black">
        Results per page
      </Typography>
      {/* <div className="relative flex h-12 box-border px-3 py-2 items-center gap-2 rounded bg-white min-w-[91px] border-secondary-50 border-sm"></div> */}
      <div className="relative">
        <select
          value={itemsPerPage}
          onChange={handleItemsPerPageChange}
          className="appearance-none h-12 box-border border-secondary-100 border-sm rounded bg-white min-w-[91px] px-3 py-2 font-body text-base leading-6 text-secondary-200 focus:outline-none  focus:ring-primary focus:border-primary focus:ring-0 cursor-pointer"
          style={{ borderRadius: '4px' }}
        >
          {itemsPerPageOptions.map((option) => (
            <option key={option.value} value={option.value} className="text-secondary-200">
              {option.label}
            </option>
          ))}
        </select>
        <Icon
          name="ChevronDown"
          size={24}
          className="absolute right-[13px] top-1/2 transform -translate-y-1/2 pointer-events-none"
        />
      </div>
    </div>
  );
}
